module.exports = __webpack_public_path__ + "static/img/SketchPng29b88cf4425898ab742ae57e53ee4f6631ac3edf66ae68e5b7773292c150fc24.c29cfc8c.png";